import { CJEvent } from '@teetsh/app/src/types/event';

export function getSeancesByClassroomIds(seances: CJEvent[]): {
  [key: string]: CJEvent[];
} {
  return seances.reduce(
    (acc, num) => ({
      ...acc,
      ...num.classroomIds.reduce(
        (acc2, num2) => ({
          ...acc2,
          [num2]: [...(acc[num2] || []), ...(acc2[num2] || []), num],
        }),
        {},
      ),
    }),
    {} as { [key: string]: CJEvent[] },
  );
}
